import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  // p {
  //   text-indent: 1.2em;
  // }
  
  // p a {
  //   // display: inline;
  //   text-indent: 0; /* 👈 prevents extra spacing for inline links */
  // }  

  .role {
    color: var(--green);
    font-style: italic;
  }

  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;

      &:after {
        top: 15px;
        left: 15px;
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 20px;
      left: 20px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'Python',
    'Secure Code Review',
    'OWASP Top 10',
    'OWASP LLM Top 10',
    'Burp Suite',
    'Semgrep',
    'Threat Modeling',
    'AI Red Teaming',
    'Reverse Engineering',
    'More',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              I’m Bibek Neupane. I graduate in May 2028, and I’m vice president of the{' '}
              <a
                href="https://www.wpunj.edu/campus-life/student-organizations/"
                target="_blank"
                rel="noreferrer">
                WPU Cybersecurity Club
              </a>
              .
            </p>

            <p>
              It started with editing coin values in Android games. That turned into reading
              about how software breaks, and then into doing it for work.
            </p>

            <p>
              Since then I’ve worked as a <span className="role">Security Analyst</span> at{' '}
              <a href="https://cynicaltechnology.com/" target="_blank" rel="noreferrer">
                Cynical Technology
              </a>{' '}
              and, last summer, as an{' '}
              <span className="role">Application Security Intern</span> at{' '}
              <a href="https://www.eclinicalworks.com/" target="_blank" rel="noreferrer">
                eClinicalWorks
              </a>
              .
            </p>

            <p>
              Currently, I’m a <span className="role">Research Assistant</span> at the{' '}
              <a
                href="https://www.wpunj.edu/cosh/departments/computer-science/Research/cybersecurity-research-lab"
                target="_blank"
                rel="noreferrer">
                WPU Cybersecurity Research Lab
              </a>
              , working on AI and LLM security for web applications and servers.
            </p>

            <p>Some of what I work with:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/nb1b3k.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
